/**
 * Forgot Password Recovery flow types
 */

define(function(require, exports, module) {
    'use strict';

    module.exports = {
        BY_EMAIL: 0,
        BY_VERIFICATION_QUESTION: 1
    };
});